/*
  AYO offer guard: a Duo deal set (two lines added together from a duo landing page, same _set) only keeps
  its offer pieces together. If one piece of a set is removed or changed, the other piece of that set is
  taken out of the bag too, so an offer-only piece cannot be bought alone. Uneven quantities are evened down.
*/
(function () {
  if (window.__ayoOfferGuard) return;
  window.__ayoOfferGuard = true;
  const root = () => ((window.routes && window.routes.cart_url) || '/cart').replace(/\/cart$/, '');
  let busy = false;

  async function check() {
    if (busy) return;
    busy = true;
    try {
      const res = await fetch(`${root()}/cart.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const sets = {};
      (cart.items || []).forEach((l) => {
        const p = l.properties || {};
        if (p._bundle === 'Duo deal' && p._set) (sets[p._set] = sets[p._set] || []).push(l);
      });
      // a set needs both pieces in the same quantity: a lone piece is removed, uneven quantities are evened down
      const updates = {};
      Object.values(sets).forEach((lines) => {
        if (lines.length !== 2) { lines.forEach((l) => { updates[l.key] = 0; }); return; }
        const q = Math.min(lines[0].quantity, lines[1].quantity);
        lines.forEach((l) => { if (l.quantity !== q) updates[l.key] = q; });
      });
      if (!Object.keys(updates).length) return;
      await fetch(`${root()}/cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      const msg = window.ayoOfferMsg || '';
      try { if (msg) sessionStorage.setItem('ayo-offer-msg', msg); } catch (e) { /* ignore */ }
      window.location.reload();
    } catch (e) {
      /* never block the page */
    } finally {
      busy = false;
    }
  }

  function note() {
    let msg = '';
    try { msg = sessionStorage.getItem('ayo-offer-msg') || ''; sessionStorage.removeItem('ayo-offer-msg'); } catch (e) { /* ignore */ }
    if (!msg) return;
    const el = document.createElement('div');
    el.className = 'ayo-offer-note';
    el.setAttribute('role', 'status');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;left:50%;bottom:calc(96px + env(safe-area-inset-bottom));transform:translateX(-50%);z-index:9999;max-width:calc(100% - 32px);padding:12px 18px;border-radius:16px;background:#fff;color:#241c33;font-size:14px;box-shadow:0 10px 30px rgba(60,30,110,.25);text-align:center';
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 5000);
  }

  const later = () => setTimeout(check, 400);
  document.addEventListener('ayo:cart-changed', later);
  const hook = () => { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, later); };
  const start = () => { hook(); note(); if ((window.ayoCartCount || 0) > 0) check(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
